@let hasLabels = this.hasLabels();
@let labels = this.labels();
@let steps = this.steps();
@let selectedIndex = this.selectedIndex();
@let debug = this.debug();
@let processTitle = this.processTitle();

@if (hasLabels) {
  <nav class="pt-5" aria-label="{{ processTitle | translate }}">
    <ol
      class="step-navigation"
      [style.--step-navigation-steps-count]="labels?.length || steps?.length"
      [style.--step-navigation-steps-complete]="selectedIndex"
    >
      @for (label of labels; track $index) {
        @let id = 'progress-bar-step-' + $index;
        @let isCurrent = $index === selectedIndex;
        @let status = getStatus($index, isCurrent) | translate;

        <li
          class="step-navigation-step rounded-3"
          [id]="id"
          [class.step-navigation-step-complete]="$index < selectedIndex"
          [class.step-navigation-step-active]="isCurrent"
          [attr.aria-current]="isCurrent ? 'step' : null"
        >
          <div class="step-navigation-step-counter" aria-hidden="true"></div>
          <div class="step-navigation-step-label text-center text-nowrap" aria-hidden="true">
            {{ label | translate }}
          </div>
          <span class="visually-hidden">{{ label | translate }} {{ status }}</span>
        </li>
      }

      @for (step of steps; track $index) {
        @let id = 'progress-bar-step-' + $index;
        @let label = step.label$ | async | translate;
        @let isCurrent = $index === selectedIndex;
        @let isFocusable = step.focusable$ | async;
        @let status = getStatus($index, isCurrent) | translate;

        <li
          class="step-navigation-step rounded-3"
          (keydown)="isFocusable && onKeyDown($event, step.step)"
          [id]="id"
          [class.step-navigation-step-complete]="$index < selectedIndex"
          [class.step-navigation-step-active]="isCurrent"
          [class.step-navigation-step-focusable]="isFocusable"
          [class.pointer]="isFocusable"
          [attr.tabIndex]="isFocusable ? 0 : null"
          [attr.aria-current]="isCurrent ? 'step' : null"
        >
          <div class="step-navigation-step-counter" aria-hidden="true"></div>
          <div class="step-navigation-step-label text-center text-nowrap" aria-hidden="true">
            {{ label | translate }}

            @if (debug) {
              <br />
              {{ (step.canSkip$ | async) ? 'skip +' : 'skip X' }} | {{ (step.depsFulfilled$ | async) ? 'deps +' : 'deps X' }}
              <br />
              {{ (step.canEnter$ | async) ? 'canEnter' : 'cannotEnter' }}
              <br />
              {{ step.stateTags }}
            }
          </div>
          <span class="visually-hidden">{{ label | translate }} {{ status }}</span>
        </li>
      }
    </ol>
  </nav>
}
